/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Steps_TitleInputs */

const en_svc_n8n_steps_title = /** @type {(inputs: Svc_N8n_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How we build n8n workflows.`)
};

const lv_svc_n8n_steps_title = /** @type {(inputs: Svc_N8n_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā mēs veidojam n8n darba plūsmas.`)
};

/**
* | output |
* | --- |
* | "How we build n8n workflows." |
*
* @param {Svc_N8n_Steps_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_steps_title = /** @type {((inputs?: Svc_N8n_Steps_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Steps_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_steps_title(inputs)
	return en_svc_n8n_steps_title(inputs)
});